<template>
<div class="nkn-cooperater">
  <div class="cooperater-row block-inner">
    <div class="common-title exchanges-title">{{$t("about.exchangeTitle")}}</div>
    <div class="exchanges-block block-content clearfix">
      <div class="exchanges-icon">
        <a href="https://www.binance.com/en/trade/NKN_USDT/" target="_blank">
          <img v-lazy="'/static/img/about/exchanges/Binance-Horizontal-cmyk.png'" class="pic-exchanges-binanace"/></a>
      </div>
      <div class="exchanges-icon">
        <a href="https://www.hbg.com/en-us/exchange/nkn_usdt/" target="_blank">
          <img v-lazy="'/static/img/about/exchanges/huobi_global.png'" class="pic-exchanges-huobi"/></a>
      </div>
      <div class="exchanges-icon">
        <a href="https://international.bittrex.com/Market/Index?MarketName=BTC-NKN" target="_blank"><img v-lazy="'/static/img/about/exchanges/bittrex.png'" class="pic-exchanges-bittrex"/></a>
      </div>
      <div class="exchanges-icon">
        <a v-if="lang === 'en'"  href="https://www.gate.io/trade/NKN_USDT" target="_blank"><img v-lazy="'/static/img/about/exchanges/gate.png'" class="pic-exchanges-gate"/></a>
        <a v-else  href="https://www.gateio.io/trade/NKN_USDT" target="_blank"><img v-lazy="'/static/img/about/exchanges/gate.png'" class="pic-exchanges-gate"/></a>
      </div>
      <div class="exchanges-icon">
        <a href="https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN" target="_blank"><img v-lazy="'/static/img/about/exchanges/upbit.svg'" class="pic-exchanges-upbit"/></a>
      </div>
      <div class="exchanges-icon">
        <a href="https://idex.market/eth/nkn" target="_blank"><img v-lazy="'/static/img/about/exchanges/IDEX.svg'" class="pic-exchanges-idex"/></a>
      </div>
      <!--<div class="exchanges-icon">
        <a href="https://www.huobi.co.kr/" target="_blank">
          <img v-lazy="'/static/img/about/exchanges/huobi_korea.png'" class="pic-exchanges-huobi"/></a>
      </div>-->
      <!--<div class="exchanges-icon">
        <a href="https://switcheo.exchange/markets/NKN_ETH" target="_blank"><img v-lazy="'/static/img/about/exchanges/switcheo.png'" class="pic-exchanges-switcheo"/></a>
      </div>-->
      <!--
      <div class="exchanges-icon">
        <a href="https://bit.ly/2Eq9Fxn" target="_blank"><img v-lazy="'/static/img/about/exchanges/LATOKEN.png'" class="pic-exchanges-LATOKEN"/></a>
      </div>
      <div class="exchanges-icon">
        <a href="https://www.bcex.top/trade/nkn_eth" target="_blank"><img v-lazy="'/static/img/about/exchanges/bcex.png'" class="pic-exchanges-bcex"/></a>
      </div>
      -->
      <!--<div class="exchanges-icon">
        <a href="https://www.bitrue.com/trade/nkn_btc" target="_blank"><img v-lazy="'/static/img/about/exchanges/bitrue.png'" class="pic-exchanges-bitrue"/></a>
      </div>-->
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      lang: 'getLang'
    })
  }
}
</script>

<style lang="scss" scoped>
.nkn-cooperater {
    padding: 0;
    margin: 0 auto;
    text-align: center;

    .cooperater-row {
      padding-top: 40px;
      @media screen and (max-width: 768px) {
        padding-top: 0;
      }
    }

    .block-inner {
      .block-content {
        @include common-inner();

        @media screen and (max-width: 768px) {
          padding: 0 0 0 20px;
        }
      }
    }

    .block-inner:nth-child(even) {
      background-color: #ffffff;
    }

    .exchanges-title {
      margin-bottom: -20px;

      @media screen and (max-width: 768px) {
        padding: 20px;
        margin: 0;
      }
    }

    .exchanges {
      &-block {
        margin-top: 5.25rem;
      }

      &-icon {
        float: left;
        width: 33%;
        /*height: auto !important;*/
        line-height: 5.375rem;

        @media screen and (max-width: 768px) {
          width: 33%;
          margin-top: 2rem;
          margin-left: 1rem;

          img {
            width: 100px;
            height: auto;
          }
        }
      }

      &-icon:nth-child(1) {
        img {
          width: 200px;
        }
      }

      &-icon:nth-child(2) {
        img {
          width: 200px;
        }
      }

      &-icon:nth-child(3) {
        img {
          width: 120px;
        }
      }

      &-icon:nth-child(4) {
        img {
          width: 120px;
        }
      }

      &-icon:nth-child(5) {
        img {
          width: 100px;
          margin-left: 20px;
        }
      }

      &-icon:nth-child(6) {
        img {
          width: 100px;
        }
      }

      /*
      &-icon:nth-child(6) {
        img {
          width: 120px;
          margin-left: 20px;
        }
      }

      &-icon:nth-child(7) {
        img {
          width: 50px;
          margin-left: 20px;
        }
      }

      &-icon:nth-child(8) {
        img {
          width: 70px;
          margin-left: 20px;
        }
      }
      */

      &-icon:nth-child(7) {
        img {
          width: 70px;
          margin-left: 20px;
        }
      }

      /*mobile*/
      @media screen and (max-width: 768px) {
        &-icon {
          margin: 0;
          width: 33.3333%;
          text-align: center;
          margin-left: -4px;
        }
        &-icon:nth-child(1) {
            img {
                  width: 120px;
            }
        }
        &-icon:nth-child(2) {
          img {
            width: 110px;
          }
        }

        &-icon:nth-child(3) {
          img {
            width: 90px;
          }
        }

        &-icon:nth-child(4) {
          img {
            width: 80px;
          }
        }

        &-icon:nth-child(5) {
          img {
            width: 60px;
          }
        }

        &-icon:nth-child(6) {
          img {
            width: 70px;
          }
        }

        /*
        &-icon:nth-child(6) {
          img {
            width: 75px;
          }
        }

        &-icon:nth-child(7) {
          margin-left: 0;
          img {
            width: 35px;
          }
        }

        &-icon:nth-child(8) {
          img {
            width: 55px;
            margin-top: 10px;
          }
        }
        */
        &-icon:nth-child(7) {
          img {
            width: 55px;
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/about/nknExchanges.vue